import React from 'react';
import { useWalkthrough } from '../context/walkthroughContext';

export default function WTTest() {
  console.log('🚨🚨🚨 WTTest component rendering');
  
  const wt = useWalkthrough();
  console.log('🚨🚨🚨 WTTest - walkthrough context:', wt);
  
  return (
    <div style={{ padding: '20px' }}>
      <h1>Walkthrough Test Page</h1>
      <p>This page tests if the walkthrough context is working.</p>
      <button 
        onClick={() => {
          console.log('🚨🚨🚨 Button clicked, starting walkthrough');
          wt.startWalkthrough();
        }}
        style={{ padding: '10px', margin: '10px', backgroundColor: '#1b263b', color: 'white', border: 'none' }}
      >
        Start Walkthrough
      </button>
      <button 
        onClick={() => {
          console.log('🚨🚨🚨 Button clicked, resetting walkthrough');
          wt.resetWalkthrough();
        }}
        style={{ padding: '10px', margin: '10px', backgroundColor: '#f9f8f6', color: '#0d0d0d', border: '1px solid #0d0d0d' }}
      >
        Reset Walkthrough
      </button>
      
      <button 
        onClick={() => {
          console.log('🧹 Clearing all localStorage flags');
          localStorage.removeItem('hasSeenWalkthrough');
          localStorage.removeItem('userSessionStarted');
          window.location.reload();
        }}
        style={{ padding: '10px', margin: '10px', backgroundColor: '#ff6b6b', color: 'white', border: 'none' }}
      >
        Clear All Flags & Reload
      </button>
      <div>
        <p>Walkthrough state:</p>
        <pre>{JSON.stringify({ 
          showWalkthrough: wt.showWalkthrough, 
          isNewUser: wt.isNewUser 
        }, null, 2)}</pre>
      </div>
    </div>
  );
}
